import { combineReducers, Reducer } from "redux";
import { persistStore, persistReducer } from "redux-persist";
// defaults to localStorage for web
import storage from "redux-persist/lib/storage";
import listReducer from "./List/reducer";
import userReducer from "./User/reducer";
import screenReducer from "./Screen/reducer";
import { configureStore } from "@reduxjs/toolkit";
import { PersistPartial } from "redux-persist/es/persistReducer";

const rootReducer = combineReducers({
  user: userReducer,
  list: listReducer,
  screen: screenReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["screen"]
};

const persistedReducer = persistReducer<RootState & PersistPartial>(
  persistConfig,
  rootReducer as any
);
const store = configureStore({ reducer: persistedReducer });
const persistor = persistStore(store as any);

export { store, persistor };

// // Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch;
